import { AuthService } from 'src/app/core/services/auth.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlansService } from 'src/app/core/services/plans.service';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { RequestVarificationComponent } from 'src/app/shared/modals/interests/request-varification/request-varification.component';

@Component({
  selector: 'app-cancel-subscription',
  templateUrl: './cancel-subscription.component.html',
  styleUrls: ['./cancel-subscription.component.scss']
})
export class CancelSubscriptionComponent implements OnInit {

  @Input() public activePlanId;
  @Input() public expiresOn;
  @Input() public forStatus;
  @Input() public requestParam;
  @Input() public errorMessage;
  @Input() public purchaseBBB;
  @Input() public tokenPromo;
  @Input() public addon;

  currentUser: any = [];
  currentToken: any;

  constructor(
    private activeModal: NgbActiveModal,
    private _planService: PlansService,
    private _authService: AuthService,
    private modalService: NgbModal,
    private _spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
    this.currentToken = this.currentUser.token;
  }

  successClose(success?: boolean, errors?) {
    if(this.forStatus){

    
    if (this.forStatus == 'buy' || this.forStatus == 'upgrade') {
      this.activeModal.close({
        forStatus: this.forStatus
      });
    }
    else if (this.forStatus == 'cancel') {
      if (success == true) {
        this.activeModal.close({
          status: success,
          forStatus: this.forStatus,
          message: LITERALS.AUTH.SUCCESS_MESSAGES.UNSUBSCRIBE_SUCCESS
        });
      }
      else if (success == false) {
        this.activeModal.close({
          status: success,
          forStatus: this.forStatus,
          message: (errors == 'already_cancelled') ? LITERALS.AUTH.ERROR_MESSAGES.USER_HAS_ALREADY_CANCEL_SUBSCRIPTION : LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG
        });
      }
    } else if (this.forStatus == 'renew') {
      if (success == true) {
        this.activeModal.close({
          status: success,
          forStatus: this.forStatus,
          message: 'Subscription Auto-renewal has been re-enabled successfully.'
        });
      }
      else if (success == false) {
        this.activeModal.close({
          status: success,
          forStatus: this.forStatus,
          message: errors
        });
      }
    }

    else if (this.forStatus == 'wipod') {
      this.activeModal.close({
        forStatus: this.forStatus
      });
    } else if (this.forStatus == 'bbbPlan') {
      this.activeModal.close({
        forStatus: this.forStatus
      });
    }
  } else {
    this.modalService.dismissAll();
  }
  }

  cancelSubscription() {
    this._spinner.show();
    this._planService.cancelSubscription(this.activePlanId).subscribe(
      (response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.successClose(true);
        }
        else {
          this.successClose(false, response.errors);
        }
      }, (error: any) => {
        this.successClose(false);
      })
  }

  autoRenewSubscription() {
    this._spinner.show();
    const params = {
      "renew_eligible": true
    }
    this._planService.autoRenewSubscription(params).subscribe(
      (response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.successClose(true);
        }
        else {
          this.successClose(false, response.errors);
        }
      }, (error: any) => {
        this.successClose(false);
      })
  }

  buyAddOns() {
    this.closeDialog(true);
    // this._spinner.show();
    // this._planService.buyAddons(this.requestParam).subscribe(
    //   (response: any) => {
    //     this._spinner.hide();
    //     this.closeDialog();
    //     if (response.success && response.data && response.data.failed_add_on.length == 0) {
    //       this.getUserData();
    //       const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
    //       modalRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.ADD_ONS_PURCHASE_SUCCESS;
    //     }
    //     else if (response.success && response.data && response.data.failed_add_on.length > 0) {
    //       const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
    //       modalRef.componentInstance.message = response.data.failed_add_on[0].message;
    //     }
    //     else {
    //       const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
    //       modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    //     }
    //   });
  }

  getUserData() {
    this._authService.getCurrentUserData(this.currentUser.user.id).subscribe(
      (response: any) => {
        if (response.success) {
          this.redirectUser(response.data.user);
        }
      });
  }

  buyWithWallet() {
    this.activeModal.close('wallet');
  }
  buyWithPromoCode() {
    // console.log('promo')
    this.activeModal.close({
      forStatus: this.forStatus,
      type: 'promocode'
    });
    // this.activeModal.close('promocode');
  }

  redirectUser(userObj) {
    const currentUser = {
      token: this.currentToken,
      user: userObj
    }

    this.currentUser = currentUser;
    let rememberMe = localStorage.getItem('rememberMe');

    if (rememberMe == 'true')
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    else
      sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
  }

  openRequestModal() {
    const modalRef = this.modalService.open(RequestVarificationComponent, { size: 'lg', centered: true, backdrop: false });
    modalRef.componentInstance.currentUser = this.currentUser;

    modalRef.result.then((result) => {
      this.closeDialog(result);
    })
  }

  closeDialog(status?) {
    this.activeModal.close(status);
  }

}
